// const ReportpageAI = {
//   reportleftcontainer: {
//     display: "flex",
//     gap: "20px",
//   },
//   tripbtn: {
//     backgroundColor: "rgb(241,241,241)",
//     color: "green",
//     borderRadius: "25px",
//     paddingLeft: "34px",
//     paddingRight: "34px",
//     fontSize: "1rem",
//   },
//   consingmentbtn: {
//     backgroundColor: "rgb(241,241,241)",
//     color: "green",
//     borderRadius: "25px",
//     paddingLeft: "34px",
//     paddingRight: "34px",
//     fontSize: "1rem",
//   },
//   secondcontainer: {
//     display: "flex",
//     justifyContent: "",
//   },
//   firstcontan: {
//     display: "flex",
//     justifyContent: "space-between",
//     alignItems: "center",
//     width: "100%",
//     marginTop: "18px",
//   },
//   overview: {
//     flexgrow: "1",
//   },
//   controls: {
//     display: "flex",
//     justifyContent: "flex-end",
//     gap: "10px",
//   },
//   subcontainer: {
//     marginLeft: "10px",
//   },
//   custmbtn: {
//     padding: "10px",
//     paddingLeft: "22px",
//     paddingRight: "26px",
//     borderRadius: "25px",
//     border: "1px solid rgb(237,237,241)",
//     textAlign: "center",
//   },
//   filterbtn: {
//     width: "45px",
//     height: "42px",
//     borderRadius: "50%",
//     border: "1px solid rgb(237,237,241) ",
//     backgroundColor: "rgb(235,247,237)",
//   },
//   exportbtn: {
//     width: "45px",
//     height: "42px",
//     borderRadius: "50%",
//     border: "1px solid rgb(237,237,241) ",
//     backgroundColor: "rgb(235,247,237)",
//   },
//   numberbox: {
//     display: "flex",
//     justifyContent: "space-evenly",
//     alignItems: "center",
//     marginTop: "35px",
//     backgroundColor: "rgb(244,244,244)",
//     borderRadius: "15px",
//   },
//   box1: {
//     display: "flex",
//     flexDirection: "column",
//     justifyContent: "center",
//     alignItems: "center",
//     textAlign: "center",
//     // padding: "12px",
//     flex: "1",
//     position: "relative",
//   },
//   triphead:{
//     marginTop:"27px",
//     backgroundColor:"RED"

//   },
//   verticalLine: {
//     position: "absolute",
//     right: "0",
//     top: "25%",
//     height: "50%",
//     width: "1px",
//     backgroundColor: "gray",
//   },
//   lastBox: {
//     borderRight: "none",
//   },
//   charts: {
//     display: "flex",
//     justifyContent: "center",
//   },

//   contchart: {
//     display: "flex",
//     flexDirection: "column",
//     alignItems: "",
//     border: "1px solid rgb(244,244,244)",
//     width: "400px",
//     height: "250px",
//     marginTop: "20px",
//     padding: "10px",
//   },
//   label: {
//     display: "flex",
//     justifyContent: "flex-start",
//     marginBottom: "10px",
//   },
//   charts: {
//     display: "flex",
//     flexDirection: "row",
//     justifyContent: "space-between",
//     alignItems: "flex-start",
//     gap: "20px",
//     flexWrap: "wrap",
//   },
//   contchart: {
//     flex: "1 1 45%",
//     minWidth: "300px",
//   },
//   firstbox: {
//     flex: "1 1 45%",
//     minWidth: "300px",
//     display: "flex",
//     flexDirection: "column",
//     alignItems: "center",
//   },

//   label: {
//     fontSize: "18px",
//     marginBottom: "5px",
//   },
//   donut: {
//     width: "100%",
//     maxWidth: "300px",
//     marginBottom: "10px",
//   },
//   circleContainer: {
//     display: "flex",
//     flexDirection: "column",
//     alignItems: "center",
//     gap: "20px",
//     marginTop: "20px",
//   },
//   circleRow: {
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "space-between",
//     width: "100%",
//     maxWidth: "400px",
//     width: "100%",
//     maxWidth: "400px",
//     marginTop: "-10px",
//   },
//   creatingc: {
//     width: "20px",
//     height: "20px",
//     borderRadius: "50%",
//     backgroundColor: "rgb(13,178,24)",
//     marginRight: "10px",
//   },
//   newcolor: {
//     width: "20px",
//     height: "20px",
//     borderRadius: "50%",
//     backgroundColor: "rgb(190,0,104)",
//     marginLeft: "10px",
//     marginRight: "10px",
//   },
//   nameText: {
//     fontSize: "16px",
//     color: "#333",
//   },
//   table: {
//     marginTop: "40px",
//   },
//   reportleftcontainer: {
//     display: "flex",
//     gap: "20px",
//   },
//   tripbtn: {
//     backgroundColor: "rgb(241,241,241)",
//     color: "green",
//     borderRadius: "25px",
//     paddingLeft: "34px",
//     paddingRight: "34px",
//     fontSize: "1rem",
//   },
//   consingmentbtn: {
//     backgroundColor: "rgb(241,241,241)",
//     color: "green",
//     borderRadius: "25px",
//     paddingLeft: "34px",
//     paddingRight: "34px",
//     fontSize: "1rem",
//   },
//   secondcontainer: {
//     display: "flex",
//     justifyContent: "",
//   },
//   firstcontan: {
//     display: "flex",
//     justifyContent: "space-between",
//     alignItems: "center",
//     width: "100%",
//     marginTop: "18px",
//   },
//   overview: {
//     flexgrow: "1",
//   },
//   controls: {
//     display: "flex",
//     justifyContent: "flex-end",
//     gap: "10px",
//   },
//   subcontainer: {
//     marginLeft: "10px",
//   },
//   custmbtn: {
//     padding: "10px",
//     paddingLeft: "22px",
//     paddingRight: "26px",
//     borderRadius: "25px",
//     border: "1px solid rgb(237,237,241)",
//     textAlign: "center",
//   },
//   filterbtn: {
//     width: "45px",
//     height: "42px",
//     borderRadius: "50%",
//     border: "1px solid rgb(237,237,241) ",
//     backgroundColor: "rgb(235,247,237)",
//   },
//   exportbtn: {
//     width: "45px",
//     height: "42px",
//     borderRadius: "50%",
//     border: "1px solid rgb(237,237,241) ",
//     backgroundColor: "rgb(235,247,237)",
//   },
//   numberbox: {
//     display: "flex",
//     justifyContent: "space-evenly",
//     alignItems: "center",
//     marginTop: "35px",
//     backgroundColor: "rgb(244,244,244)",
//     borderRadius: "15px",
//   },
//   box1: {
//     display: "flex",
//     flexDirection: "column",
//     justifyContent: "center",
//     alignItems: "center",
//     textAlign: "center",
//     padding: "12px",
//     flex: "1",
//     position: "relative",
//   },
//   donut: {
//     width: "100%",
//     maxWidth: "400px",
//     height: "",
//   },
//   charts: {
//     display: "flex",
//     flexDirection: "row",
//     justifyContent: "space-between",
//     alignItems: "flex-start",
//     gap: "20px",
//     flexWrap: "wrap",
//   },
//   contchart: {
//     flex: "1 1 45%",
//     minWidth: "300px",
//   },
//   firstbox: {
//     flex: "1 1 45%",
//     minWidth: "300px",
//     display: "flex",
//     flexDirection: "column",
//     alignItems: "center",
//     border: "1px solid rgb(237,237,242)",
//     borderRadius: "20px",
//     marginTop: "22px",
//   },

//   label: {
//     fontSize: "18px",
//     marginBottom: "5px",
//   },
//   donut: {
//     width: "100%",
//     maxWidth: "300px",
//     marginBottom: "10px",
//   },
//   circleContainer: {
//     display: "flex",
//     flexDirection: "column",
//     alignItems: "center",
//     gap: "20px",
//     marginTop: "20px",
//   },
//   circleRow: {
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "space-between",
//     width: "100%",
//     maxWidth: "400px",
//     width: "100%",
//     maxWidth: "400px",
//     marginTop: "-10px",
//   },
//   creatingc: {
//     width: "20px",
//     height: "20px",
//     borderRadius: "50%",
//     backgroundColor: "rgb(13,178,24)",
//     marginRight: "10px",
//   },
//   newcolor: {
//     width: "20px",
//     height: "20px",
//     borderRadius: "50%",
//     backgroundColor: "rgb(190,0,104)",
//     marginLeft: "10px",
//     marginRight: "10px",
//   },
//   nameText: {
//     fontSize: "16px",
//     color: "#333",
//   },
//   table: {
//     marginTop: "40px",
//   },
//   table: {
//     marginTop: "35px",
//   },
//   //
//   reportleftcontainer: {
//     display: "flex",
//     gap: "20px",
//   },
//   tripbtn: {
//     backgroundColor: "rgb(241,241,241)",
//     color: "green",
//     borderRadius: "25px",
//     paddingLeft: "34px",
//     paddingRight: "34px",
//     fontSize: "1rem",
//   },
//   consingmentbtn: {
//     backgroundColor: "rgb(241,241,241)",
//     color: "green",
//     borderRadius: "25px",
//     paddingLeft: "34px",
//     paddingRight: "34px",
//     fontSize: "1rem",
//   },
//   secondcontainer: {
//     display: "flex",
//     justifyContent: "",
//   },
//   firstcontan: {
//     display: "flex",
//     justifyContent: "space-between",
//     alignItems: "center",
//     width: "100%",
//     marginTop: "18px",
//   },
//   overview: {
//     flexgrow: "1",
//   },
//   controls: {
//     display: "flex",
//     justifyContent: "flex-end",
//     gap: "10px",
//   },
//   subcontainer: {
//     marginLeft: "10px",
//   },
//   custmbtn: {
//     padding: "10px",
//     paddingLeft: "22px",
//     paddingRight: "26px",
//     borderRadius: "25px",
//     border: "1px solid rgb(237,237,241)",
//     textAlign: "center",
//   },
//   filterbtn: {
//     width: "45px",
//     height: "42px",
//     borderRadius: "50%",
//     border: "1px solid rgb(237,237,241) ",
//     backgroundColor: "rgb(235,247,237)",
//   },
//   exportbtn: {
//     width: "45px",
//     height: "42px",
//     borderRadius: "50%",
//     border: "1px solid rgb(237,237,241) ",
//     backgroundColor: "rgb(235,247,237)",
//   },
//   numberbox: {
//     display: "flex",
//     justifyContent: "space-evenly",
//     alignItems: "center",
//     marginTop: "35px",
//     backgroundColor: "rgb(244,244,244)",
//     borderRadius: "15px",
//   },
//   box1: {
//     display: "flex",
//     flexDirection: "column",
//     justifyContent: "center",
//     alignItems: "center",
//     textAlign: "center",
//     padding: "12px",
//     flex: "1",
//     position: "relative",
//   },

//   charts: {
//     display: "flex",
//     flexDirection: "row",
//     justifyContent: "space-between",
//     alignItems: "flex-start",
//     gap: "20px",
//     flexWrap: "wrap",
//   },
//   contchart: {
//     flex: "1 1 45%",
//     minWidth: "300px",
//   },
//   firstbox: {
//     flex: "1 1 45%",
//     minWidth: "300px",
//     display: "flex",
//     flexDirection: "column",
//     alignItems: "center",
//     border: "1px solid rgb(237,237,242)",
//     borderRadius: "20px",
//     marginTop: "22px",
//   },

//   label: {
//     fontSize: "18px",
//     marginBottom: "5px",
//   },
//   donut: {
//     width: "100%",
//     maxWidth: "300px",
//     marginBottom: "10px",
//   },
//   circleContainer: {
//     display: "flex",
//     flexDirection: "column",
//     alignItems: "center",
//     gap: "20px",
//     marginTop: "20px",
//   },
//   circleRow: {
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "space-between",
//     width: "100%",
//     maxWidth: "400px",
//     width: "100%",
//     maxWidth: "400px",
//     marginTop: "-10px",
//   },
//   creatingc: {
//     width: "20px",
//     height: "20px",
//     borderRadius: "50%",
//     backgroundColor: "rgb(13,178,24)",
//     marginRight: "10px",
//   },
//   newcolor: {
//     width: "20px",
//     height: "20px",
//     borderRadius: "50%",
//     backgroundColor: "rgb(190,0,104)",
//     marginLeft: "10px",
//     marginRight: "10px",
//   },
//   nameText: {
//     fontSize: "16px",
//     color: "#333",
//   },
//   table: {
//     marginTop: "40px",
//   },
//   table: {
//     marginTop: "35px",
//   },
//   charthalf: {
//     border: "1px solid  lightgray",
//     marginTop: "20px",
//     borderRadius: "16px",
//   },
//   loadingtimechart: {
//     marginTop: "28px",
//     borderRadius: "16px",
//     border: "1px solid  lightgray",
//   },
//   consingmentstatus: {
//     padding:"20px",
//     marginLeft: "20px",
//   },
//   loadingtime: {
//     padding:"20px",
//     marginLeft: "20px",
//   },
//   // consingmentstatus: {
//   //   marginLeft: "20px",
//   // },
//   // loadingtime: {
//   //   marginLeft: "20px",
//   // },
//   popup: {
//     display: "flex",
//     justifyContent: "center",
//   },
//   containbox: {
//     display: "flex",
//     justifyContent: "flex-start",
//   },
//   dividingbox: {
//     display: "flex",
//     justifyContent: "flex-start",
//     gap: "20px",
//     flexWrap: "wrap",
//     width: "100%",
//   },
//   vehicle: {
//     flexBasis: "22%",
//     width: "100%",
//   },
//   select: {
//     width: "100%",
//     height: "2.5em",
//     fontSize: "10px",
//     padding: "13px",
//     borderRadius: "15px",
//     border: "1px solid #5F6D8C",
//   },
//   fourresult: {
//     fontSize: "26px",
//     color: "rgb(44,150,61)",
//   },
//   clearall: {
//     backgroundColor: "rgb(44,150,61)",
//     color: "white",
//     paddingLeft: "24px",
//     paddingRight: "24px",
//     paddingTop: "14px",
//     paddingBottom: "14px",
//     borderRadius: "25px",
//     border: "none",
//   },
//   able: {
//     justifyContent: "center",
//     display: "flex",
//     color: "#5F6D8C",
//   },
// };

// export default ReportpageAI;

import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Tab } from "../../../Reusablecomponents/Tab";
import TripReport from "../TripReportAI/TripReportAI";
import ConsignmentReport from "../ConsignmentReportAI/Consignmentreport";

import { Radio } from "antd";
import { useLocation, useParams } from "react-router-dom";
const GreenRadio = styled(Radio)`
  .ant-radio-inner {
    border-color: green; // Change the border color
  }
  .ant-radio-checked .ant-radio-inner {
    background-color: green; // Change the background color when checked
    border-color: green; // Change the border color when checked
  }
  .ant-radio-wrapper {
    color: green; // Change the text color
  }
`;

const Customstyle = styled.div`
  background-color: white;

  .topstyle {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: white;
  }
  @media (max-width: 480px) {
    .ant-tabs .ant-tabs-tab + .ant-tabs-tab {
      margin-left: 7px;
    }
    .ant-tabs-nav-list {
      flex-direction: column;
      margin: 0px 0px 0px 8px;
    }
    .topstyle {
      flex-direction: column;
      gap: 10px;
    }
    .searchstle {
      flex-direction: column;
      align-self: flex-end;
    }
    .total {
      align-self: flex-start;
    }
  }
  .ant-tabs-nav-list {
    margin-top: 20px;
  }
  .total {
    color: #5f6d8c;
    font-size: 16px;
    font-weight: 400;
  }
  .searchstle {
    display: flex;
    align-items: center;
    gap: 15px;
  }
  .filterstyle {
    height: 25px;
    width: 25px;
  }
  .badg {
    padding: 6px;
  }
  .custom-row-height {
    height: 88px !important; /* Set desired row height */
  }
  .tablestyle {
    // padding-left: 30px;
  }
  .switc {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .create_btn_customization {
    margin-left: auto;
  }
`;

const TripReportPage = () => {
  const [activekey, setactivekey] = useState("1");
  const [selectedReport, setSelectedReport] = useState("Trips"); // State to track selected radio button
  const location = useLocation();
  //navigate the kpi report page on home page KPI ALERTS
  useEffect(() => {
    if (location.state?.tab) {
      setactivekey(location.state.tab);
    }
  }, [location.state]);

  const tabItems = [
    { label: "Trip Reports", key: "1" },
    { label: "Consignment Reports", key: "2" },
  ];
  return (
    <Customstyle>
      <Tab defaultActiveKey="1" items={tabItems} onChange={setactivekey} />
      <div className="px-3">
        {activekey === "1" && <div className="topstyle"></div>}
        {activekey === "2" && <div className="topstyle"></div>}
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between", // Align title to the left and icons to the right
          alignItems: "center",
        }}
        className="px-3"
      ></div>

      {activekey === "1" && (
        <>
          <div className="px-3" style={{ marginTop: "16px" }}>
            {selectedReport === "Trips" && <TripReport />}
          </div>
        </>
      )}
      {activekey === "2" && (
        <div className="px-3" style={{ marginTop: "16px" }}>
          <ConsignmentReport activekey={activekey} />
        </div>
      )}
    </Customstyle>
  );
};

export default TripReportPage;
